import React from 'react'
import { Button, Grid, Typography } from '@mui/material'
import RecipeListCard from '../../../components/RecipeListCard';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../../hooks/useIsMobile';
import { useDispatch, useSelector } from 'react-redux';
import useCurrentUserInfo from '../../../hooks/useCurrentUserInfo';
import _ from 'lodash';
import { chefDeleteRecipe } from '../../../redux/actions/recipeActions';

function RecipeLibraryControl() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useCurrentUserInfo();
  const mobile = useIsMobile();

  const chefAdminRecipeData = useSelector((state) => state.chefAdminRecipeData);
  const chefAdminRecipes = chefAdminRecipeData?.chefAdminRecipes;

  const navigateAddRecipePage = () => {
    navigate('/add-recipe');
  };

  const handleDeleteRecipe = (recipeId) => {
    dispatch(
      chefDeleteRecipe({
        userId: userInfo?.user_id,
        recipeId: recipeId
      })
    )
  };

  return (
    <Grid sx={{ width: '100%', display: 'flex', flexDirection: 'column'}}>
      <Grid item display={'flex'} justifyContent={'center'} width={'100%'}>
        {
          chefAdminRecipes?.length ? (
            <Button 
              variant='contained' 
              color='primary' 
              sx={{ 
                marginTop: '2rem',
                marginBottom: '2rem', 
                width: '85%',
                maxWidth: '25rem'
              }}
              onClick={navigateAddRecipePage}
            >
              <Typography variant='h5'>
                Add Recipe
              </Typography>
            </Button>
          ) : null
        }
      </Grid>
      <Grid 
        item 
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center', // Change from 'center' to prevent centering content
          width: '100%',
          flexGrow: 1, // Add this
          overflow: 'auto', // Change from 'scroll' to 'auto'
          flexDirection: 'column',
          height: mobile ? '75dvh' : '65dvh',
          '&::-webkit-scrollbar': {
            width: '0.4em'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0,0,0,.1)',
            borderRadius: '24px'
          }
        }}
      >
        { chefAdminRecipes.length ? 
          (
            chefAdminRecipes?.map((recipe) => (
              <RecipeListCard 
                recipeTitle={recipe?.title}
                id={recipe?._id}
                imageSrc={recipe?.picture}
                handleDeleteRecipe={handleDeleteRecipe}
              />
            ))
          ) : (
            <Grid 
              display={'flex'} 
              justifyContent={'center'} 
              alignItems={'center'} 
              flexDirection={'column'}
              sx={{ height: '100%', width: '100%'}}
            >
              <img 
                height={'250px'}
                width={'250px'}
                src={'https://res.cloudinary.com/djrbfvpit/image/upload/v1738176898/CloudSous%20Assets/chefrobomascot_mhxtel.png'} 
                alt={'CloudSous Logo'} 
                style={{ marginBottom: '2rem' }}
              />
              <Typography variant='h5' textAlign={'center'}>
                Click the button to add your first recipe!
              </Typography>
              <Button 
                variant='contained' 
                color='primary' 
                sx={{ 
                  marginTop: '2rem',
                  marginBottom: '2rem', 
                  width: '85%',
                  maxWidth: '25rem'
                }}
                onClick={navigateAddRecipePage}
              >
                <Typography variant='h5'>
                  Add Recipe
                </Typography>
              </Button>
            </Grid>
          )
        }
      </Grid>
    </Grid>
  )
}

export default RecipeLibraryControl;